import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  CircularProgress,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Paper,
  Backdrop,
  FormControl,
  Typography,
  Grid,
} from "@mui/material";
import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import ResponsiveDrawer from "../../components/ClippedResponsiveDrawer";
import { useState } from "react";
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { getSettlementList, updateClosingInventory, updateLastKnownInventory } from "../../utils/GetPlanning";
import ChangeClosingInvHeader from "./AdjustClosingInvHeader";
import _ from "lodash";
import moment from "moment";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
// import { DatePicker, LocalizationProvider } from "@mui/lab";
// import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'

interface MatDesc {
  materialNum: string;
  materialNumShort: string;
  description: string;
}
interface Settlement {
  shipmentNum: string;
  customerNum: string;
  customerName: string;
  isModified: boolean;
  visitNum: string;
  visitDt: string;
  txSettlementItems: [];
}

interface SettlementData {
  matDetails: MatDesc[];
  settlements: any;
  selectedSettlement: Settlement;
  visitPlanningItemList?: any;
  reconciliationNotes?: string;
  isReconciliationAvailable?: boolean;
  isReconciliationSelected?: boolean;
  isReconciliationModified?: boolean;
  visitPlanningListBackup?: any;
  lastInventoryUpdateDate?: any;
}

export const editable = { isEdit: false };
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root: {},
    typography: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(1),
    },
    table: {},
    formControl: {
      float: "right",
    },
    chipActual: {
      marginTop: theme.spacing(2),
      marginRight: theme.spacing(1),
      marginBottom: theme.spacing(2),
    },
    chipEFDisplay: {
      marginTop: -theme.spacing(1),
      marginRight: theme.spacing(1),
      marginBottom: -theme.spacing(1),
    },
    titleItemRight: {
      color: "white",
      backgroundColor: "blue",
      float: "right",
    },
    grid: {},
  })
);

export default function AdjustClosingInventory() {
  enum SelectionType {
    None = "",
    Settlement = "Settlement",
    Customer = "Customer",
  }
  const classes = useStyles();
  const [closingInvUpdateState, setClosingInvUpdateState] = useState<SettlementData>({
    //customerNum: '',
    //equipmentAssigns: {},
    matDetails: [],
    settlements: [],
    selectedSettlement: {
      shipmentNum: "",
      customerNum: "",
      customerName: "",
      isModified: false,
      visitDt: "",
      visitNum: "",
      txSettlementItems: [],
    },
  });
  const [isLoadingState, setIsLoadingState] = useState(false);
  const [isOverlayLoading, setShowOverlayLoading] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [changedSelectionDataType, setChangedSelectionDataType] = useState<SelectionType>(SelectionType.None);
  const [changedSelectionData, setChangedSelectionData] = useState({});
  const [errorMessage, setErrorMessage] = useState<{ title: string; message: string } | undefined>(undefined);
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");

  const showLoading = (showLoading: boolean) => {
    setIsLoadingState(showLoading);
  };
  const showOverlayLoading = (showLoading: boolean) => {
    setShowOverlayLoading(showLoading);
  };

  const saveAndProceedNext = () => {
    saveSettlementChanges();
    setOpenConfirm(false);
  };

  const dismissAndProceed = () => {
    if (changedSelectionDataType === SelectionType.Settlement.valueOf()) {
      switchToSelectedSettlement(changedSelectionData);
    } else if (changedSelectionDataType === SelectionType.Customer.valueOf()) {
      //const selecedCustomer:any =changedSelectionData.customerNum;
      switchToSelectedCustomer(changedSelectionData);
    } else {
      //Nothing.Skip selection change for now
    }
    setOpenConfirm(false);
  };

  const isPastDate = (date: MaterialUiPickersDate): boolean => {
    const inpDate = moment(date);
    if (inpDate.isBefore(moment(closingInvUpdateState?.visitPlanningItemList[0]?.last_visit_dt))) {
      return true;
    } else {
      return false;
    }
  };

  const formatDateLabel = (date: MaterialUiPickersDate, invalidLabel: string) => {
    if (isPastDate(date)) {
      return "Please select date after last settlement date";
    }
    const inpDate = moment(date);
    return date && inpDate.isValid() ? inpDate.format("dddd, MMMM Do YYYY") : invalidLabel;
  };

  const handleInventoryDateChange = (newDate: any) => {
    if (!isPastDate(newDate)) {
      setClosingInvUpdateState({
        ...closingInvUpdateState,
        lastInventoryUpdateDate: newDate,
      });
    } else {
      setClosingInvUpdateState({
        ...closingInvUpdateState,
        lastInventoryUpdateDate: closingInvUpdateState?.visitPlanningItemList[0]?.last_inventory_update_dt,
      });
      const date = moment(closingInvUpdateState?.visitPlanningItemList[0]?.last_visit_dt).format("dddd, MMMM Do YYYY");

      setErrorMessage({
        title: "Date Selection Denied!",
        message: `Please select a date greater or equal to last settlement date: ${closingInvUpdateState?.visitPlanningItemList[0]?.last_visit_dt}.`,
      });
    }
  };

  const resetSettlementState = () => {
    setClosingInvUpdateState({
      matDetails: [],
      settlements: [],
      selectedSettlement: {
        shipmentNum: "",
        customerNum: "",
        customerName: "",
        isModified: false,
        visitDt: "",
        visitNum: "",
        txSettlementItems: [],
      },
      isReconciliationAvailable: false,
      isReconciliationSelected: false,
      reconciliationNotes: "",
      visitPlanningItemList: [],
    });
  };

  const handleSettlementDateSelChange = (selctedSettlement: any, loading: boolean) => {
    if (closingInvUpdateState.selectedSettlement.isModified) {
      setOpenConfirm(true);
      setChangedSelectionDataType(SelectionType.Settlement);
      setChangedSelectionData({ ...selctedSettlement });
      setClosingInvUpdateState({
        ...closingInvUpdateState,
        isReconciliationModified: false,
        isReconciliationAvailable:
          selctedSettlement.shipmentNum === closingInvUpdateState?.visitPlanningItemList[0].last_shipment_num,
      });
    } else {
      switchToSelectedSettlement(selctedSettlement);
      setOpenConfirm(false);
    }
  };

  const switchToSelectedSettlement = (selctedSettlement: any) => {
    showLoading(true);
    setClosingInvUpdateState({
      ...closingInvUpdateState,
      selectedSettlement: selctedSettlement,
      isReconciliationAvailable:
        selctedSettlement.shipmentNum === closingInvUpdateState?.visitPlanningItemList[0].last_shipment_num,
    });
    setChangedSelectionDataType(SelectionType.None);
    setChangedSelectionData({});
    showLoading(false);
  };
  const handleCustomerInputChange = (salesOrg: string, customerNum: string, loading: boolean) => {
    if (customerNum) {
      if (closingInvUpdateState.selectedSettlement.isModified) {
        setOpenConfirm(true);
        setChangedSelectionDataType(SelectionType.Customer);
        setChangedSelectionData(customerNum);
      } else {
        switchToSelectedCustomer(customerNum);
      }
    }
  };

  const switchToSelectedCustomer = (selctedCustomer: any) => {
    setOpenConfirm(false);
    showLoading(true);
    showOverlayLoading(true);
    getSettlementList(salesOrg, selctedCustomer).then((resp: any) => {
      if (resp) {
        resp.settlements[0]?.txSettlementItems?.forEach((e: any) => {
          resp.visitPlanningItemList.map((o: any) => {
            if (e.materialNum === o.material_num) {
              o.closingInventory = e.closingInventory;
              o.consignment = e.consignment;
              o.orderNum = e.orderNum;
              o.matDesc = e.matDesc;
              o.quantity = e.quantity;
              o.isModified = false;
            }
          });
        });
        setClosingInvUpdateState({
          matDetails: resp.matDesc,
          settlements: resp.settlements,
          selectedSettlement:
            resp.settlements && resp.settlements.length > 0
              ? resp.settlements[0]
              : {
                  shipmentNum: "",
                  customerNum: "",
                  customerName: "",
                  isModified: false,
                  visitDt: "",
                  visitNum: "",
                  txSettlementItems: [],
                },
          visitPlanningItemList: resp?.visitPlanningItemList || [],
          visitPlanningListBackup: [...resp?.visitPlanningItemList],
          reconciliationNotes: resp?.visitPlanningItemList[0]?.text,
          lastInventoryUpdateDate: resp?.visitPlanningItemList[0]?.last_inventory_update_dt,
          isReconciliationAvailable:
            resp.settlements[0]?.shipmentNum === resp?.visitPlanningItemList[0].last_shipment_num,
        });
        showLoading(false);
        showOverlayLoading(false);
        setChangedSelectionDataType(SelectionType.None);
        setChangedSelectionData({});
      } else {
        showLoading(false);
        showOverlayLoading(false);
        alert("search criteria result not found");
      }
    });
  };

  const handleEditLastKnownInventory = (event: any) => {
    event.preventDefault();
    const i = parseInt(event.target.name);
    if (!isNaN(i) && closingInvUpdateState.visitPlanningItemList?.length > 0) {
      const list: any = _.cloneDeep(closingInvUpdateState.visitPlanningItemList);
      const currentCInv = list[i].last_inventory;
      var newCInv: any = Number(event.target.value) < 0 ? 0 : Number(event.target.value) || 0;
      if (list[i].consignment && newCInv > list[i].consignment) {
        newCInv = currentCInv;
        alert("Last Known inventory should be less than consignment quantity");
      } else if (!list[i].consignment && newCInv > currentCInv) {
        alert(
          "Modifing Historic Settlement. Please make sure  Updated last known inventory is less than consignment quantity"
        );
      }
      if (!list[i].hh_last_known_inventory) {
        list[i].hh_last_known_inventory = currentCInv;
      }
      list[i].last_inventory = newCInv;
      setClosingInvUpdateState({
        ...closingInvUpdateState,
        visitPlanningItemList: list,
        isReconciliationModified: true,
      });
    }
  };

  const handleEditInventory = (event: any) => {
    event.preventDefault();
    const i = parseInt(event.target.name);

    if (!isNaN(i) && closingInvUpdateState.selectedSettlement) {
      const selSettlement: any = _.cloneDeep(closingInvUpdateState.selectedSettlement); //{...closingInvUpdateState.selectedSettlement};
      let newCInv: number = Number(event.target.value) || 0;
      const currentCInv = selSettlement.txSettlementItems[i].closingInventory;
      if (newCInv < 0) newCInv = 0;
      if (selSettlement.txSettlementItems[i].consignment && newCInv > selSettlement.txSettlementItems[i].consignment) {
        newCInv = currentCInv;
        alert("Closing inventory should be less than consignment quantity");
      } else {
        if (!selSettlement.txSettlementItems[i].consignment && newCInv > currentCInv) {
          alert(
            "Modifing Historic Settlement. Please make sure  Updated Closing inventory is less than consignment quantity"
          );
        }
      }
      if (!selSettlement.txSettlementItems[i].hhclosingInventory) {
        selSettlement.txSettlementItems[i].hhclosingInventory = currentCInv;
      }
      event.target.value = "" + newCInv;
      selSettlement.txSettlementItems[i].closingInventory = newCInv;
      selSettlement.isModified = true;
      setClosingInvUpdateState({
        ...closingInvUpdateState,
        selectedSettlement: selSettlement,
      });
    }
  };

  const saveLastKnownInventoryList = () => {
    showOverlayLoading(true);
    updateLastKnownInventory(
      salesOrg,
      closingInvUpdateState.selectedSettlement.customerNum,
      closingInvUpdateState.selectedSettlement.shipmentNum,
      closingInvUpdateState.visitPlanningItemList[0]?.last_order_num,
      closingInvUpdateState.visitPlanningItemList,
      closingInvUpdateState.reconciliationNotes,
      closingInvUpdateState.lastInventoryUpdateDate
    ).then((v: any) => {
      closingInvUpdateState.visitPlanningItemList.map((e: any) => {
        e.text = closingInvUpdateState.reconciliationNotes;
      });
      setClosingInvUpdateState({
        ...closingInvUpdateState,
        visitPlanningListBackup: closingInvUpdateState.visitPlanningItemList,
      });
      alert("Last Known Inventory Updated Successfully.");
      showOverlayLoading(false);
      setOpenConfirm(false);
    });
  };

  const handleSaveReconciliationClick = (e: any) => {
    e?.preventDefault();
    saveLastKnownInventoryList();
  };

  const handleSaveSettlementClick = (e: any) => {
    // Update settlements List and update selectedsettlement as well
    e.preventDefault();
    saveSettlementChanges();
  };

  const saveSettlementChanges = () => {
    showOverlayLoading(true);
    //console.log(changedSelectionData);
    if (closingInvUpdateState.selectedSettlement.customerNum) {
      updateClosingInventory(
        salesOrg,
        closingInvUpdateState.selectedSettlement.customerNum,
        closingInvUpdateState.selectedSettlement.shipmentNum,
        closingInvUpdateState.selectedSettlement.txSettlementItems
      ).then((v: any) => {
        if (v) {
          if (changedSelectionDataType === SelectionType.Settlement.valueOf()) {
            const updatedSettlements = _.cloneDeep(closingInvUpdateState.settlements);
            let updatedSettlement = _.cloneDeep(closingInvUpdateState.selectedSettlement);
            const index = updatedSettlements.findIndex(
              (settlement: any) => settlement.shipmentNum === closingInvUpdateState.selectedSettlement.shipmentNum
            );
            updatedSettlement.isModified = false;
            updatedSettlements[index] = updatedSettlement;
            const switchSettlementItem: any =
              changedSelectionDataType === SelectionType.Settlement.valueOf() &&
              changedSelectionData &&
              Object.keys(changedSelectionData).length > 0
                ? changedSelectionData
                : updatedSettlement;
            setClosingInvUpdateState({
              ...closingInvUpdateState,
              settlements: updatedSettlements,
              selectedSettlement: switchSettlementItem,
            });
            setChangedSelectionDataType(SelectionType.None);
            setChangedSelectionData({});
          } else if (changedSelectionDataType === SelectionType.Customer.valueOf()) {
            switchToSelectedCustomer(changedSelectionData);
          } else {
            //Nothing. Skip selection change for now
          }
          setOpenConfirm(false);
          alert("Closing Inventory Updated Successfully.");
        }
        showOverlayLoading(false);
      });
    }
  };

  const toggleReconciliation = (isSelected: boolean = false) => {
    setClosingInvUpdateState({
      ...closingInvUpdateState,
      isReconciliationSelected: isSelected,
      visitPlanningItemList: closingInvUpdateState.visitPlanningListBackup,
      reconciliationNotes: closingInvUpdateState?.visitPlanningItemList[0]?.text,
      isReconciliationModified: false,
    });
  };

  return (
    <ResponsiveDrawer title="Edit Closing Inventory">
      <ChangeClosingInvHeader
        onCusSelectionChange={handleCustomerInputChange}
        onSettlementDateSelChange={handleSettlementDateSelChange}
        resetSettlementState={resetSettlementState}
        showLoading={showLoading}
        settlementsData={closingInvUpdateState.settlements}
        selectedSettlement={closingInvUpdateState.selectedSettlement}
      />
      {isLoadingState && <CircularProgress />}

      <Grid
        className={classes.grid}
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={2} md={2} lg={2} xl={2}>
          {!isLoadingState && closingInvUpdateState?.settlements?.length > 0 && (
            <Button
              color="primary"
              variant={!closingInvUpdateState.isReconciliationSelected ? "contained" : "outlined"}
              onClick={() => toggleReconciliation(false)}
            >
              Adjust Closing Inventory
            </Button>
          )}
        </Grid>
        <Grid item xs={3} md={3} lg={3} xl={3}>
          {!isLoadingState && closingInvUpdateState?.isReconciliationAvailable && (
            <Button
              variant={closingInvUpdateState.isReconciliationSelected ? "contained" : "outlined"}
              onClick={() => toggleReconciliation(true)}
            >
              Adjust Last Known Inventory
            </Button>
          )}
        </Grid>

        <Grid item xs={2} md={2} lg={2} xl={2}>
          {closingInvUpdateState?.isReconciliationSelected && closingInvUpdateState?.isReconciliationAvailable && (
            <FormControl className={classes.formControl}>
              <TextField
                id={"Reconciliation"}
                label={"Reconciliation Notes"}
                value={closingInvUpdateState.reconciliationNotes}
                name={"Reconciliation"}
                placeholder={"Reconciliation Notes"}
                onChange={(e) => {
                  setClosingInvUpdateState({
                    ...closingInvUpdateState,
                    reconciliationNotes: e.target.value,
                  });
                }}
              ></TextField>
            </FormControl>
          )}
        </Grid>
        <Grid item xs={2} md={2} lg={2} xl={2}>
          {closingInvUpdateState?.isReconciliationSelected && closingInvUpdateState?.isReconciliationAvailable && (
            <LocalizationProvider dateAdapter={AdapterDateFns} className={classes.formControl}>
              <DatePicker
                value={closingInvUpdateState.lastInventoryUpdateDate}
                onChange={handleInventoryDateChange}
                renderInput={(props:any) => <TextField {...props} variant="outlined" label={formatDateLabel} fullWidth />}
              />
            </LocalizationProvider>
          )}
        </Grid>
        <Grid item xs={3} md={3} lg={3} xl={3}>
          {!isLoadingState &&
            closingInvUpdateState?.settlements?.length > 0 &&
            (!closingInvUpdateState.isReconciliationSelected || !closingInvUpdateState?.isReconciliationAvailable) && (
              <Button
                variant="outlined"
                className={classes.titleItemRight}
                disabled={!closingInvUpdateState.selectedSettlement.isModified}
                onClick={handleSaveSettlementClick}
              >
                Save Closing Inventory
              </Button>
            )}
          {!isLoadingState &&
            closingInvUpdateState.isReconciliationSelected &&
            closingInvUpdateState?.isReconciliationAvailable && (
              <Button
                variant="outlined"
                className={classes.titleItemRight}
                disabled={!closingInvUpdateState.isReconciliationModified}
                onClick={handleSaveReconciliationClick}
              >
                Save Last Known Inventory
              </Button>
            )}
        </Grid>
      </Grid>

      {!isLoadingState &&
        closingInvUpdateState?.settlements?.length > 0 &&
        (!closingInvUpdateState.isReconciliationSelected || !closingInvUpdateState?.isReconciliationAvailable) && (
          <TableContainer component={Paper}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>Material</TableCell>
                  <TableCell align="justify">Consignment</TableCell>
                  <TableCell align="justify">Fill Quantity</TableCell>
                  <TableCell align="justify">Original Closing Inventory</TableCell>
                  <TableCell align="justify">Closing Inventory</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {closingInvUpdateState.selectedSettlement &&
                  closingInvUpdateState.selectedSettlement.txSettlementItems.map((row: any, index: number) => {
                    return (
                      <TableRow key={index}>
                        <TableCell component="th" scope="row">
                          {row.matDesc}
                        </TableCell>
                        <TableCell align="justify" size={"medium"}>
                          {" "}
                          {row.consignment ? row.consignment : "-"}{" "}
                        </TableCell>
                        <TableCell align="justify"> {row.quantity} </TableCell>
                        <TableCell align="justify"> {row.hhclosingInventory ? row.hhclosingInventory : "-"} </TableCell>
                        <TextField
                          id={index.toString()}
                          type="number"
                          value={row.closingInventory}
                          name={"" + index}
                          size="small"
                          inputProps={{
                            inputmode: "numeric",
                            pattern: "[0-9]*",
                          }}
                          onChange={handleEditInventory}
                        ></TextField>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        )}

      {!isLoadingState &&
        closingInvUpdateState.isReconciliationSelected &&
        closingInvUpdateState?.isReconciliationAvailable && (
          <TableContainer component={Paper}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>Material</TableCell>
                  <TableCell align="justify">Consignment</TableCell>
                  <TableCell align="justify">Fill Quantity</TableCell>
                  <TableCell align="justify">Original Last Known Inventory</TableCell>
                  <TableCell align="justify">Last Known Inventory</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {closingInvUpdateState.visitPlanningItemList.map((row: any, index: number) => {
                  return (
                    <TableRow key={index}>
                      <TableCell component="th" scope="row">
                        {row.matDesc}
                      </TableCell>
                      <TableCell align="justify" size={"medium"}>
                        {row.consignment ? row.consignment : "-"}
                      </TableCell>
                      <TableCell align="justify"> {row.quantity} </TableCell>
                      <TableCell align="justify">
                        {row.hh_last_known_inventory ? row.hh_last_known_inventory : "-"}
                      </TableCell>
                      <TextField
                        id={index.toString()}
                        type="number"
                        value={row.last_inventory}
                        name={index.toString()}
                        size="small"
                        inputProps={{
                          inputmode: "numeric",
                          pattern: "[0-9]*",
                        }}
                        onChange={handleEditLastKnownInventory}
                      ></TextField>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      <Dialog fullWidth={true} maxWidth="md" aria-labelledby="dri-title" open={openConfirm} onClose={dismissAndProceed}>
        <DialogTitle id="dri-title">Confirm Activity</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            You have unsaved changes in inventory.Do you wish to save before moving to another?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={dismissAndProceed} color="primary">
            No, Dismiss and Proceed
          </Button>
          <Button onClick={saveAndProceedNext} color="primary" autoFocus>
            Yes,Save and Proceed
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth={true}
        maxWidth="md"
        aria-labelledby="dri-title"
        open={errorMessage !== undefined}
        onClose={() => {
          setErrorMessage(undefined);
        }}
      >
        <DialogTitle>{errorMessage?.title}</DialogTitle>
        <DialogContent>
          <Typography paragraph>{errorMessage?.message}</Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setErrorMessage(undefined);
            }}
            color="primary"
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }} open={isOverlayLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </ResponsiveDrawer>
  );
}
